module.exports = __webpack_public_path__ + "static/media/Nachiket_Deshmukh.31d64875.jpg";